import { i18n } from '@lingui/core'
import type { Artifact } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'

export function formatArtifactDate(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleDateString(i18n.locale || 'en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/** "<site name> · <date>", or the date alone when the backend sent no site name; the site id is never printed. */
export function artifactSiteLine(
  artifact: Pick<Artifact, 'site_name' | 'updated_at'>
): string {
  const date = formatArtifactDate(artifact.updated_at)
  return artifact.site_name ? `${artifact.site_name} · ${date}` : date
}
